import {useFormik} from 'formik'
import * as Yup from 'yup'
import {Button, Card, Col, Form, Row, Spinner} from 'react-bootstrap'
import {useEffect, useState} from 'react'
import {KTIcon} from '../../../../../_metronic/helpers'
import {useMutation} from '@apollo/client'
import {EDIT_PASSWORD_USER_FROM_ADMIN} from '../../../graphql/mutations/userMutations'
import {parseId} from '../../../helpers'
import {toast} from 'react-toastify'
import {IResChangePassword} from '../../../graphql/types/usersTypes'

const validationSchema = Yup.object({
  password: Yup.string()
    .min(8, 'La contraseña debe tener al menos 8 caracteres')
    .matches(
      /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d@$!%*?&-]{8,}$/,
      'La contraseña debe contener al menos una letra y un número'
    )
    .required('Contraseña es requerida'),
  passwordConfirm: Yup.string()
    .oneOf([Yup.ref('password')], 'Las contraseñas no coinciden')
    .required('Obligatorio'),
})

interface ISecurity {
  id: string
  refetch: () => void
}

export const SecurityOneUser: React.FC<ISecurity> = ({id, refetch}) => {
  const [gqlChangePass, {data, loading, error}] = useMutation<IResChangePassword>(
    EDIT_PASSWORD_USER_FROM_ADMIN
  )
  const [isShowPass, setIsShowPass] = useState(false)
  const [isShowConfirmPass, setIsShowConfirmPass] = useState(false)
  const formik = useFormik({
    initialValues: {
      password: '',
      passwordConfirm: '',
    },
    validationSchema,
    onSubmit: (values) => {
      gqlChangePass({
        variables: {
          input: {
            ...values,
            id: parseId(id),
          },
        },
      })
    },
  })

  useEffect(() => {
    if (!data) return
    if (data.userChangePassword.success) {
      toast.success('Contraseña actualizada correctamente')
      refetch()
      formik.resetForm()
    } else if (data.userChangePassword.errors) {
      toast.error(`Error: ${data.userChangePassword.errors.message}`)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  useEffect(() => {
    if (error) toast.error(`Error: ${error.message}`)
  }, [error])

  return (
    <Card className='animation animation-fade-in'>
      <Card.Body>
        <Card>
          <Card.Header>
            <Card.Title>Editar contraseña</Card.Title>
          </Card.Header>

          <Card.Body>
            <Form onSubmit={formik.handleSubmit} id='formId'>
              <Row>
                <Col sm={12} md={6}>
                  <Form.Group className='mt-3 position-relative' controlId='password'>
                    <Form.Label>Contraseña</Form.Label>
                    <Form.Control
                      type={isShowPass ? 'text' : 'password'}
                      name='password'
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.password}
                      isInvalid={Boolean(formik.touched.password && formik.errors.password)}
                    />
                    <button
                      style={{
                        position: 'absolute',
                        right: formik.touched.password && formik.errors.password ? '30px' : '5px',
                        top: formik.errors.password && formik.errors.password ? '40px' : '55%',
                      }}
                      type='button'
                      className='btn-reset'
                      onClick={() => setIsShowPass((p) => !p)}
                    >
                      {isShowPass ? (
                        <i className='bi bi-eye-slash-fill fs-5 text-dark' />
                      ) : (
                        <i className='bi bi-eye-fill fs-5 text-dark' />
                      )}
                    </button>
                    <Form.Control.Feedback type='invalid'>
                      {formik.errors.password}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col sm={12} md={6}>
                  <Form.Group className='mt-3 position-relative' controlId='passwordConfirm'>
                    <Form.Label>Confirmación de contraseña</Form.Label>
                    <Form.Control
                      type={isShowConfirmPass ? 'text' : 'password'}
                      name='passwordConfirm'
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.passwordConfirm}
                      isInvalid={Boolean(
                        formik.touched.passwordConfirm && formik.errors.passwordConfirm
                      )}
                    />
                    <button
                      style={{
                        position: 'absolute',
                        right:
                          formik.touched.passwordConfirm && formik.errors.passwordConfirm
                            ? '30px'
                            : '5px',
                        top:
                          formik.errors.passwordConfirm && formik.errors.passwordConfirm
                            ? '40px'
                            : '55%',
                      }}
                      type='button'
                      className='btn-reset'
                      onClick={() => setIsShowConfirmPass((p) => !p)}
                    >
                      {isShowConfirmPass ? (
                        <i className='bi bi-eye-slash-fill fs-5 text-dark' />
                      ) : (
                        <i className='bi bi-eye-fill fs-5 text-dark' />
                      )}
                    </button>
                    <Form.Control.Feedback type='invalid'>
                      {formik.errors.passwordConfirm}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          </Card.Body>

          <Card.Footer>
            <div className='d-flex align-items-center justify-content-end w-100'>
              <Button variant='warning' type='submit' form='formId' disabled={loading}>
                {loading && <Spinner animation='border' size='sm' className='me-2' />}
                <KTIcon iconName='information-4' className='fs-2' />
                Cambiar
              </Button>
            </div>
          </Card.Footer>
        </Card>
      </Card.Body>
    </Card>
  )
}
